import Swal from "sweetalert2";
import { Field, Form } from 'react-final-form';
import React, { useState, useEffect } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import renderSelectField from '@/shared/components/form/Select';
import renderCheckBoxField from '@/shared/components/form/CheckBox';
import renderComponentField from '@/shared/components/form/FormField';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { CollectionCategoryEnum, CollectionCardinalDirectionEnum } from '../../../../../Enums';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const required = value => (value ? undefined : 'Required')

const CollectionsList = (props) => {
    const [collectionsList, setCollectionsList] = useState();
    const GetCollections = () => {
        AdminInterface.instance.getCollections().then((response) => {
            setCollectionsList(response.data)
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        }).finally(() => {
            props.setListRequiresReload(false);
        });
    }

    useEffect(() => {
        GetCollections();
    }, []);

    const submitNewCollection = (collection) => {
        let data = {};
        data.name = collection.name;
        data.category = collection.category?.value;
        data.parent_id = collection.parent_id?.value;
        data.default_bucket_name = collection.default_bucket_name;
        data.is_demonstrable = collection.is_demonstrable != undefined ? collection.is_demonstrable != undefined : false;
        data.is_exportable = collection.is_exportable != undefined ? collection.is_exportable != undefined : false;
        AdminInterface.instance.createCollection(data).then(() => {
            withReactContent(Swal).fire({
                icon: 'success',
                title: 'Success',
                html: 'New collection is created!',
            });
            props.setListRequiresReload(true);
        }).catch((error) => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: error.response.data?.detail,
            });
        });
    }

    return (
        <Card>
            <CardBody>
                <CardTitleWrap>
                    <CardTitle>New Collection</CardTitle>
                </CardTitleWrap>
                { collectionsList && 
                <Form onSubmit={submitNewCollection}>
                    {({ handleSubmit, form }) => (
                        <FormContainer horizontal onSubmit={handleSubmit}>
                            <FormGroup>
                                <FormGroupLabel>Name</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="name" component={renderComponentField} placeholder="Name" validate={required}/>
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Parent</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="parent_id" component={renderSelectField}
                                        options={collectionsList.map(function (collection) {
                                            return { value: collection.id, label: collection.name }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Category</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="category" component={renderSelectField} validate={required}
                                        options={Object.keys(CollectionCategoryEnum).map(function (key) {
                                            return { value: CollectionCategoryEnum[key], label: key }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Default Bucket Name</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="default_bucket_name" component={renderComponentField} placeholder="For example: fm-tms"/>
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Cardinal Direction</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="cardinal_direction" component={renderSelectField}
                                        options={Object.keys(CollectionCardinalDirectionEnum).map(function (key) {
                                            return { value: CollectionCardinalDirectionEnum[key], label: key }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupField>
                                    <Field
                                        name="is_exportable"
                                        type="checkbox"
                                        component={renderCheckBoxField}
                                        label="Exportable"
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupField>
                                    <Field
                                        name="is_demonstrable"
                                        type="checkbox"
                                        component={renderCheckBoxField}
                                        label="Demonstrable"
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormButtonToolbar>
                                <Button variant="primary" type="submit">Submit</Button>
                                <Button variant="secondary" type="button" onClick={form.reset}>
                                    Cancel
                                </Button>
                            </FormButtonToolbar>
                        </FormContainer>
                    )}
                </Form>}
            </CardBody>
        </Card>
    );
};

export default CollectionsList;